export const claimsClaimHistoryColumns = [
  'id',
  'fk_subscriber_id',
  'fk_billing_provider_id',
  'fk_claims_meta_data_id',
  'claim_number',
  'claim_stmts',
  'claim_facility_and_freq_code',
  'admission_date_434',
  'discharge_date_434',
  'admission_type',
  'admission_source',
  'discharge_status',
  'treatment_authorization_code',
  'doc_control_num',
  'patient_mrn',
  'claim_refs',
  'claim_currency',
  'additional_remarks',
  'dx_primary',
  'dx_admitting',
  // this field is going to change here shortly.
  'aprdrg',
  'px_principal',
  'drg',
  'dx_list',
  'proc_list',
  'condition_list',
  'cause_of_injury_list',
  'occurrence_date_list',
  'value_codes',
  'other_payer__oi_01',
  'other_payer__oi_02',
  'other_payer__oi_03',
  'other_payer__oi_04',
  'other_payer__oi_05',
  'other_payer__oi_06',
  'other_payer__amt_type_01',
  'other_payer__amt_01',
  'other_payer__amt_type_02',
  'other_payer__amt_02',
  'other_payer__amt_type_03',
  'other_payer__amt_03',
  'other_payer__pr_cas_02',
  'other_payer__pr_cas_03',
  'other_payer__co_cas_02',
  'other_payer__co_cas_03',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'meta_scrubbed_data',
  'snapshot_id',
  'total_claim_amount',
  'estimated_amount_due',
  'prior_payments',
  'meta_lineage_content_hash',
];
